import React, { Component } from "react";
import { Load } from "./basic";
import { BootstrapTable } from "react-bootstrap-table";
import axios from "axios";
import "../../public/less/grid.less";
import dateHelper from "../../helpers/date";

module.exports = class DataGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      filteredProducts: [],
      selected: [],
      selectedByUserPreferedCol: [],
      params: this.props.parameters,
      isError: false,
      totalDataSize: 10,
      page: 1,
      itemsPerPage: 10
    };

    this.getData = this.getData.bind(this);
    this.setData = this.setData.bind(this);
    this.getTotalDataSize = this.getTotalDataSize.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.afterColumnFilter = this.afterColumnFilter.bind(this);
    this.getSelectedItemIDs = this.getSelectedItemIDs.bind(this);
    this.filterDataByDate = this.filterDataByDate.bind(this);
  }

  componentDidMount() {
    this.loadData();
    this.setBasicClassess();
    this.getTotalDataSize();
  }

  loadData(params) {
    var loading = this._loading;
    loading.Show();

    var paramsToChoose = params;

    if (paramsToChoose == undefined) {
      paramsToChoose = this.state.params;
    }

    axios
      .get(this.props.ajaxUrl, { params: paramsToChoose })
      .then(
        function(data) {
          this._loading.Hide();
          this.setState({
            data: data.data,
            filteredProducts: data.data.slice()
          });
          //console.log(data.data);
        }.bind(this)
      )
      .catch(
        function(error) {
          if (error.response && error.response.data == "No permissions") {
            window.location.replace("/login");
          }
          if (this._loading) {
            this._loading.Hide();
          }
          this.setState({ isError: true });
          console.log(error);
        }.bind(this)
      );
  }

  setNewParameters(params) {
    this.setState({ params: params });
    this.loadData(params);
    this.getTotalDataSize(params);
  }

  setBasicClassess() {
    $("table.dataGridTable").removeClass("table-bordered");
  }

  getData() {
    return this.state.data;
  }

  setData(data) {
    this.setState({ data: data });
  }

  trClassFormat(row, rowIndex) {
    // row is the current row data
    return rowIndex % 2 === 0 ? "tr-odd" : "tr-even"; // return class name.
  }

  showLoading() {
    this._loading.Show();
  }

  hideLoading() {
    this._loading.Hide();
  }

  onSelect(row, isSelected) {
    const selectedProducts = this.state.selected;
    const selectedProductsByUserPreferedCol = this.state
      .selectedByUserPreferedCol;
    if (isSelected) {
      selectedProducts.push(row.ID);
      selectedProductsByUserPreferedCol.push(row);
    } else {
      const index = selectedProducts.indexOf(row.ID);
      const indexByUser = selectedProductsByUserPreferedCol.indexOf(row);
      selectedProducts.splice(index, 1);
      selectedProductsByUserPreferedCol.splice(indexByUser, 1);
    }
    this.setState({
      selected: selectedProducts,
      selectedByUserPreferedCol: selectedProductsByUserPreferedCol
    });
  }

  onSelectAll(isSelected) {
    const items = isSelected
      ? this.state.filteredProducts.map(product => product.ID)
      : [];
    const itemsByUser = isSelected
      ? this.state.filteredProducts.map(product => product)
      : [];
    this.setState({ selected: items, selectedByUserPreferedCol: itemsByUser });
  }

  afterColumnFilter(filterConds, result) {
    //this.setState({ filteredProducts: result });
  }

  getTotalDataSize(params) {
    if (this.props.totelDataUrl) {
      var paramsToChoose = params;

      if (paramsToChoose == undefined) {
        paramsToChoose = this.state.params;
      }

      axios
        .get(this.props.totelDataUrl, { params: paramsToChoose })
        .then(
          function(data) {
            this._loading.Hide();
            this.setState({ totalDataSize: data.data[0].count });
            //console.log(data.data);
          }.bind(this)
        )
        .catch(
          function(error) {
            if (error.response && error.response.data == "No permissions") {
              window.location.replace("/login");
            }
            this._loading.Hide();
            this.setState({ isError: true });
            console.log(error);
          }.bind(this)
        );
    }
  }

  onPageChange(page, sizePerPage) {
    this.setState({
      page: page,
      itemsPerPage: sizePerPage
    });

    this.props.onPageChange(page - 1, sizePerPage);
  }

  getSelectedItemIDs() {
    return this.state.selectedByUserPreferedCol;
  }

  filterDataByDate(field, date) {
    var d = new Date(date);

    var allDataToPresent = this.state.data.filter(function(el) {
      return dateHelper.fromStrToDate(el[field]) >= d;
    });

    this.setState({ filteredProducts: allDataToPresent });
  }

  filterDataByFWVersion(field, version) {
    var allDataToPresent = this.state.data.filter(function(el) {
      return el[field] >= version;
    });

    this.setState({ filteredProducts: allDataToPresent });
  }

  removeFilters() {
    this.setState({ filteredProducts: this.state.data });
  }

  expoertCSV(dbKeys, csvKeys, fileName) {
    var data = this.refs.table.getTableDataIgnorePaging();
    this.downloadCSV(data, dbKeys, csvKeys, fileName);
  }

  convertArrayOfObjectsToCSV(args, dbKeys, csvKeys, dataFormatters) {
    var result, ctr, keys, okeys, columnDelimiter, lineDelimiter, data;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ",";
    lineDelimiter = args.lineDelimiter || "\r\n";

    keys = dbKeys || Object.keys(data[0]);
    okeys = [];

    if (csvKeys) {
      csvKeys.forEach(function(key) {
        okeys.push('"' + key + '"');
      });
    } else {
      keys.forEach(function(key) {
        okeys.push('"' + key + '"');
      });
    }

    result = "";
    result += okeys.join(columnDelimiter);
    result += lineDelimiter;

    data.forEach(item => {
      ctr = 0;
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        if (ctr > 0) result += columnDelimiter;
        var val = item[key];
        if (key == "TimeStamp" || key == "Subscribed" || key == "LastActive") {
          val = dateHelper.fromDBStrToStrWithTime(val);
        }

        if (dataFormatters) {
          if (dataFormatters[i]) {
            val = dataFormatters[i](val);
          }
        }

        if (typeof val === "string") {
          val = val
            .replace(/"/g, "")
            .replace(/{/g, "")
            .replace(/}/g, "")
            .replace(/,/g, "-")
            .trim();
        }

        if (val) {
          result += '"' + val + '"';
        } else {
          result += '""';
        }

        ctr++;
      }
      result += lineDelimiter;
    });

    return result;
  }

  downloadCSV(exportData, dbKeys, csvKeys, fileName) {
    var data, link;
    var csv = this.convertArrayOfObjectsToCSV(
      {
        data: exportData
      },
      dbKeys,
      csvKeys,
      null
    );
    if (csv == null) return;
    if (!csv.match(/^data:text\/csv/i)) {
      csv = "data:text/csv;charset=utf-8," + csv;
    }
    data = encodeURI(csv);
    link = document.createElement("a");
    link.setAttribute("href", data);
    link.setAttribute("download", fileName);
    link.click();
  }

  render() {
    const selectRowProp = {
      mode: "checkbox",
      selected: this.state.selected,
      onSelect: this.onSelect.bind(this),
      onSelectAll: this.onSelectAll.bind(this)
    };

    const options = {
      expandRowBgColor: "#E7DFED",
      onRowClick: this.props.OnClick,
      sizePerPageList: [
        {
          text: "10",
          value: 10
        },
        {
          text: "20",
          value: 20
        },
        {
          text: "25",
          value: 25
        }
      ],
      afterColumnFilter: this.afterColumnFilter,
      onFilterChange: this.props.onFilterChange
        ? this.props.onFilterChange
        : null
    };

    if (this.props.remote == true) {
      options.onSortChange = this.props.onSortChange;
      options.onPageChange = this.onPageChange;
      options.onSizePerPageList = this.props.onSizePerPageList;
      options.page = this.state.page;
      options.sizePerPage = this.state.itemsPerPage;
    }

    var trClassFormat = this.trClassFormat;
    if (this.props.trClassFormat) {
      trClassFormat = this.props.trClassFormat;
    }

    var errorClass = "hidden error";
    if (this.state.isError) {
      errorClass = "error";
    }

    return (
      <div className="DataGrid" id={this.props.ID}>
        <Load
          ref={loading => {
            this._loading = loading;
          }}
        />
        <div className={errorClass}>An error occured.</div>
        <BootstrapTable
          ref="table"
          data={this.state.filteredProducts}
          striped
          options={options}
          hover
          fetchInfo={
            this.props.remote ? { dataTotalSize: this.state.totalDataSize } : {}
          }
          cellEdit={this.props.cellEdit}
          trClassName={trClassFormat}
          expandableRow={this.props.ExpandableRow}
          pagination={this.props.pagination ? true : false}
          remote={this.props.remote ? true : false}
          selectRow={this.props.selectRow == true ? selectRowProp : {}}
          expandComponent={this.props.ExpandComponent}
          tableHeaderClass="dataGridTable"
          tableBodyClass="dataGridTable"
          tableContainerClass="dataGridTableContainer"
        >
          {this.props.children}
        </BootstrapTable>
        <link
          rel="stylesheet"
          type="text/css"
          href="/css/react-bootstrap-table-all.min.css"
        />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./modules/common/dataGrid.jsx